module.exports = __webpack_public_path__ + "img/diabetology.5a46bec7.png";